import React from 'react'
import './style.css'

function Navbar(params) {
    return(
    <div className="Navbar">
        Pokemon API
    </div>

    )
}

export default Navbar